<template>
  <div id="works-page" class="pageContainer ">
      <WorkGallery>
      </WorkGallery>
  </div>
</template>
<script>

  import BaseView from '@/components/BaseView'
  import WorkGallery from '@/components/WorkGallery'
  import Component from 'vue-class-component'


  @Component(
  {
    components: {
       WorkGallery
      }
  })
  export default class Works extends BaseView {
  }

</script>
<style lang="scss">
  #works-page {
  }
</style>